"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

require("./CollapseComponent.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Panel = _antd.Collapse.Panel;

var CollapseComponent = function CollapseComponent(_ref) {
  var showArrow = _ref.showArrow,
      panelData = _ref.panelData,
      defaultActiveKey = _ref.defaultActiveKey,
      onChange = _ref.onChange;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_antd.Collapse, {
    defaultActiveKey: [defaultActiveKey],
    onChange: onChange,
    className: "iiht-collapse"
  }, panelData === null || panelData === void 0 ? void 0 : panelData.map(function (panel) {
    return /*#__PURE__*/_react["default"].createElement(Panel, {
      showArrow: showArrow,
      header: panel === null || panel === void 0 ? void 0 : panel.panelHeader,
      key: panel === null || panel === void 0 ? void 0 : panel.id
    }, /*#__PURE__*/_react["default"].createElement("p", null, panel === null || panel === void 0 ? void 0 : panel.panelText));
  })));
};

var _default = CollapseComponent;
exports["default"] = _default;